var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasItems)?_c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item.value,staticClass:"item"},[_c('span',{class:{label: item.label}},[_vm._v("\n      "+_vm._s(item.label || item)+"\n    ")]),_vm._v("\n    "+_vm._s(item.value)+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d043cef0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 750
// module chunks = 1